import React from 'react'
import Container from '@material-ui/core/Container';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from "swiper";
import "swiper/css/effect-fade";
import imgHero from '../../assets/galeria2.jpg';
import imgHero2 from '../../assets/galeriacz1.jpg';
import imgHero3 from '../../assets/galerials2.jpg';


const HeroIndex = () => {
  return (
    <div className='heroIndex hero'>
      <Container className='relative flex flexCenter flexCol'>
        <Swiper
                spaceBetween={30}
                effect={"fade"}
                autoplay={{
                  delay: 4500,
                  disableOnInteraction: false,
                }}
                modules={[EffectFade, Autoplay]}
                className="heroSlider"
              >
                <SwiperSlide>
                  <img src={imgHero} alt="Hero 1" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={imgHero2} alt="Hero 2" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={imgHero3} alt="Hero 3" />
                </SwiperSlide>
                
              </Swiper>
            <div className="boxIndex textSection flex flexCenter flexWrap">
               <h2 className='textWhite textCenter'>Espacios exclusivos con diseños únicos</h2>
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 387.46 45.24"><path className="cls-1" fill='#3e4a43' d="M5.48,37.45a69.84,69.84,0,0,1,17.59-15.7,84.28,84.28,0,0,1,21.41-9.43C59.48,8,75.09,7.14,90.4,7.94a221.19,221.19,0,0,1,22.86,2.47c7.57,1.19,15,2.77,22.48,4.48,14.87,3.44,29.51,7.56,44.3,11S209.78,32,224.93,32s30.26-1.74,45.18-4.55,29.68-6.5,44.56-9.7c7.44-1.59,14.91-3.06,22.46-4,3.78-.51,7.57-.82,11.37-1a98.54,98.54,0,0,1,11.4.18,96.18,96.18,0,0,0-11.39,0c-3.79.24-7.58.6-11.34,1.16-7.52,1.05-15,2.62-22.38,4.29-14.81,3.39-29.52,7.29-44.46,10.28s-30.11,5.11-45.41,5.15a159.12,159.12,0,0,1-22.87-1.56c-7.56-1-15.07-2.44-22.53-4C164.6,25,149.89,21.13,135.06,18c-7.41-1.59-14.84-3-22.32-4.09a220.9,220.9,0,0,0-22.52-2.07c-15-.55-30.19.58-44.42,4.93a79.44,79.44,0,0,0-20.07,9.2A64.87,64.87,0,0,0,9.67,40.72Z"></path></svg>

            </div>
        </Container>

    </div>
  )
}

export default HeroIndex